import { kea } from 'kea'
import PropTypes from "prop-types";
import { put, call } from 'redux-saga/effects'
import { filter, forEach, get, find } from 'lodash'

import { Carts, Contacts } from "@gratify-eu/entities";

import entities from '~/entities';
import { fillWithDefaults } from '~/components/contacts'

import { form as formLogic } from './contact-form/logic'
import rootLogic from '~/scenes/logic'


export default kea({
  path: () => ['scenes', 'shipping', 'index'],

  connect: {
    actions: [
      rootLogic, [
        'next'
      ],
      formLogic, [
        'submit',
        'submitSuccess',
        'clearErrors',
        'setValues'
      ]
    ],
    values: [
      entities, [
        'activeCart',
        'shippingPrices',
        'shopShippingMethods',
        'contacts'
      ]
    ]
  },

  actions: ({ constants }) => ({
    chooseShippingMethod: (shippingMethod) => ({shippingMethod}),
    setUseBillingAddress: (value = true) => ({value}),
    setShippingMethodOptions: (options) => ({options}),
    setShippingMethodErrors: (errors) => ({errors}),
  }),

  reducers: ({ actions, constants }) => ({
    pricesLoaded: [false, PropTypes.bool, {
      [Carts.actions.shippingPrices.success]: () => true,
    }],
    useBillingAddress: [true, PropTypes.bool, {
      [actions.setUseBillingAddress]: (_, payload) => (payload.value)
    }],
    currentShippingMethodState: [null, PropTypes.string, {
      [actions.chooseShippingMethod]: (_, payload) => {
        const { shippingMethod } = payload || {};

        if(shippingMethod && shippingMethod.url) {
          return shippingMethod.url
        }

        return _;
      }
    }],
    shippingMethodErrors: [null, PropTypes.array, {
      [actions.setShippingMethodErrors]: (_, payload) => (payload.errors),
      [actions.chooseShippingMethod]: (_, payload) => (null),
      [actions.submit]: (_, payload) => (null),
    }],
    shippingMethodOptions: [{}, PropTypes.object, {
      [actions.setShippingMethodOptions]: (_, payload) => (payload.options),
    }],
  }),

  selectors : ({ constants, selectors }) => ({
    shippingMethods: [
      () => [
        selectors.activeCart,
        selectors.shippingPrices,
        selectors.shopShippingMethods,
      ], (activeCart, shippingPrices, shopShippingMethods) => {
        if (activeCart) {
          const prices = filter((shippingPrices || {})[activeCart.url], {available: true});

          let methods = [];
          forEach(prices, (price) => {
            const method = shopShippingMethods[price.url];

            if(method) {
              methods.push({
                price,
                method
              })
            }
          });

          return methods;

        }
        return null;
      },
      PropTypes.array
    ],

    billingContact: [
      () => [
        selectors.activeCart,
        selectors.contacts,
      ], (activeCart, contacts) => {
        if(activeCart && contacts) {
          if(activeCart.contact) {
            return get(contacts, activeCart.contact, null);
          }
        }

        return null;
      },
      PropTypes.object
    ],

    shippingContact: [
      () => [
        selectors.activeCart,
        selectors.contacts,
        selectors.useBillingAddress,
      ], (activeCart, contacts, useBillingAddress) => {
        if(activeCart && contacts) {
          if(activeCart.shipping_contact) {
            if(!useBillingAddress) {
              if(activeCart.shipping_contact === activeCart.contact) {
                return null;
              }
              return get(contacts, activeCart.shipping_contact, null);
            }
            return get(contacts, activeCart.shipping_contact, null);
          }
        }

        return null;
      },
      PropTypes.object
    ],

    currentShippingMethod: [
      () => [
        selectors.activeCart,
        selectors.shopShippingMethods,
        selectors.currentShippingMethodState
      ], (activeCart, shopShippingMethods, currentShippingMethod) => {
        let shippingMethod;
        if(currentShippingMethod) {
          shippingMethod = find(shopShippingMethods, {url: currentShippingMethod});

          return shippingMethod;
        }
        if(activeCart && activeCart.shipping_method) {
          shippingMethod = find(shopShippingMethods, {url: activeCart.shipping_method});
          if(shippingMethod) {
            return shippingMethod;
          }
        }

        return null;
      },
      PropTypes.object
    ]
  }),

  start: function* () {
    const { setUseBillingAddress, setValues } = this.actionCreators;
    const cart = yield this.get('activeCart');

    if(cart) {
      yield put(Carts.actions.shippingPrices.request(cart));

      if(cart.contact) {
        const billingContact = yield this.get('billingContact');

        if(!billingContact) {
          yield put(Contacts.actions.fetch.request(null, null, cart.contact));
        }
      }

      if(cart.shipping_contact && cart.shipping_contact !== cart.contact) {
        const shippingContact = yield this.get('shippingContact');
        yield put(setUseBillingAddress(false));
        if(!shippingContact) {
          const contact = yield call(Contacts.workers.fetch, Contacts.actions.fetch.request(null, null, cart.shipping_contact));
          yield put(setValues(fillWithDefaults(contact)));
        }else {
          yield put(setValues(fillWithDefaults(shippingContact)));
        }

      }
    }
  },

  takeLatest: ({ actions, workers }) => ({
    [actions.chooseShippingMethod]: function*() {
      const { clearErrors } = this.actionCreators;
      yield put(clearErrors());
    },
    [actions.submitSuccess]: function*() {
      yield put(actions.next())
    }
  })
})
